export const CORE_API = 'https://core.uniteus.io/v1/';
export const UPLOADS_API = 'https://uploads.uniteus.io/v1/';
export const LEGACY_API_URL = 'https://api.uniteus.io';
export const CORE_LEGACY_API_URL = 'https://core.uniteus.io/legacy/';
export const SERVER_URL = 'https://widgets.uniteus.io/';
export const AWS_DOC_URL = 'https://s3.amazonaws.com/documents.uniteus.io/';
export const LAUNCH_DARKLY_KEY = '67cb3815081533095a007486';
export const SCREENINGS_API = 'https://screenings-ingestion.uniteus.io/v2';
export const GOOGLE_MAPS_API_KEY = 'AIzaSyCGV28YrMBuBzlL1ntXMCvW1Z0RT1_RsVU';
export const DATADOG_RUM_ENABLED = true;
export const DATADOG_RUM_APPLICATION_ID = 'b606bad5-2a0b-4cb0-8517-4913b670ca53';
export const DATADOG_RUM_CLIENT_TOKEN = 'pub13023c8df0668e6b02d19cb5ceff1bb6';
export const DATADOG_RUM_SITE = 'ddog-gov.com';
export const DATADOG_RUM_ENV = 'production';
export const DATADOG_RUM_VERSION = '0b28a32c2271e917e39860fff3da3133c592c47c';
export const DATADOG_RUM_PROXY_URL = 'https://datadog.uniteus.io';
export const DATADOG_LOGS_ENABLED = true;
